// src/client/hooks/useCreditScore.ts
import { useQuery } from '@tanstack/react-query';
import { creditScoreService } from '@client/services';
import { ServiceError } from '@client/lib/serviceError';

export function useCreditScore() {
  return useQuery({
    queryKey: ['client', 'credit-score'],
    queryFn: async () => {
      const r = await creditScoreService.getMyScore();
      if (!r.ok) throw new ServiceError(r.error);
      return r.value;
    },
  });
}

export function useCreditScoreHistory() {
  return useQuery({
    queryKey: ['client', 'credit-score', 'history'],
    queryFn: async () => {
      const r = await creditScoreService.getScoreHistory();
      if (!r.ok) throw new ServiceError(r.error);
      return r.value;
    },
  });
}
